<template>
  <el-form ref="bidForm" @submit.native.prevent :model="budgetForm" :rules="rules" :label-width="formLabelWidth">
    <slot name="daterange">
      <el-form-item label="投放时间">
        <el-radio-group v-model="budgetForm.dateRange">
          <el-radio-button ghost :label="1">从今天起长期投放</el-radio-button>
          <el-radio-button ghost :label="2">设置开始和结束日期</el-radio-button>
        </el-radio-group>

        <div style="margin-top: 6px" v-if="budgetForm.dateRange === 2">
          <DateRangePicker v-model="budgetForm.rangeDate" :clearable="false" :picker-options="pickerOpts"></DateRangePicker>
        </div>
      </el-form-item>
    </slot>

    <el-form-item label="投放时段">
      <el-radio-group v-model="budgetForm.timeRange">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">指定时间段</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px" v-if="budgetForm.timeRange === 1">
        <DragWeektime v-model="budgetForm.time_series" :data="weektimeData" @change="onWeektimeChange"></DragWeektime>
      </div>
    </el-form-item>

    <el-form-item label="投放场景" v-if="marketingSceneType.version3 || marketingSceneType.version_smart">
      <el-radio-group v-model="budgetForm.bid_scene" @change="onBidSceneChange">
        <el-radio-button ghost :label="BID_SCENE.NORMAL_AVERAGE">常规投放</el-radio-button>
        <el-radio-button ghost :label="BID_SCENE.NORMAL_MAX">最大转化量投放</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="投放场景" v-if="marketingSceneType.version_search">
      <el-radio-group v-model="budgetForm.searchad_bid_scene">
        <el-radio-button ghost :label="1">常规投放</el-radio-button>
      </el-radio-group>

      <div>
        <el-radio-group v-model="budgetForm.bid_scene">
          <el-radio-button ghost :label="BID_SCENE.NORMAL_TARGET">放量投放</el-radio-button>
          <el-radio-button ghost :label="BID_SCENE.NORMAL_AVERAGE">稳定投放</el-radio-button>
        </el-radio-group>
      </div>
    </el-form-item>

    <el-form-item label="出价方式">
      <el-radio-group v-model="budgetForm.bid_mode" :disabled="pageStates.isUpdate">
        <el-radio-button ghost :label="BID_MODE.OCPM" :disabled="marketingSceneType.version_search">OCPM</el-radio-button>
        <el-radio-button ghost :label="BID_MODE.OCPC">OCPC</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="计划日预算" prop="daily_budget">
      <el-radio-group v-model="budgetForm.budget">
        <el-radio-button ghost :label="0" :disabled="dailyBudgetDisabled">不限</el-radio-button>
        <el-radio-button ghost :label="1">设置日预算</el-radio-button>
      </el-radio-group>

      <div class="project-budget" v-if="budgetForm.budget === 1">
        <el-input v-model="budgetForm.daily_budget" @blur="$refs.bidForm.clearValidate()" placeholder="此项目每日最高总花费"></el-input>
        <span>&ensp;每日预算50 - 40,000,000元</span>
      </div>
    </el-form-item>

    <template v-if="marketingSceneType.version_smart">
      <el-form-item label="优选版位提价">
        <el-switch v-model="budgetForm.bid_adjustment_enabled" @change="onBidAdjustmentEnabledChange"></el-switch>
      </el-form-item>

      <div v-show="budgetForm.bid_adjustment_enabled" class="bid-adjustment-panel">
        <el-form-item label="选择版位" prop="bid_adjustment_site_set">
          <el-select
            v-model="budgetForm.bid_adjustment_site_set"
            multiple
            placeholder="请选择需要提升出价的版位"
            @change="onBidAdjustmentSiteSetChange"
          >
            <el-option v-for="item in BID_ADJUSTMENT_SITE_OPTIONS" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="浅层提价系数" prop="bid_adjustment_shallow_coefficient">
          <el-input
            class="bid-adjustment-coefficient"
            v-model="budgetForm.bid_adjustment_shallow_coefficient"
            :placeholder="bidAdjustmentCoefficientPlaceholder"
            @input="onBidAdjustmentCoefficientsInput"
          ></el-input>
          <span class="bid-adjustment-tip">{{ bidAdjustmentCoefficientTip }}</span>
        </el-form-item>

        <el-form-item label="深层提价系数" prop="bid_adjustment_deep_coefficient">
          <el-input
            class="bid-adjustment-coefficient"
            v-model="budgetForm.bid_adjustment_deep_coefficient"
            :placeholder="bidAdjustmentCoefficientPlaceholder"
            @input="onBidAdjustmentCoefficientsInput"
          ></el-input>
          <span class="bid-adjustment-tip">{{ bidAdjustmentCoefficientTip }}</span>
        </el-form-item>
      </div>
    </template>

    <!-- 广告场景 腾讯广告-智投 -->
    <template v-if="marketingSceneType.version_smart">
      <!-- 小游戏起量 -->
      <template v-if="planForm.smart_delivery_platform === SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION">
        <el-form-item label="智投投放目标">
          <el-radio-group v-model="budgetForm.smart_delivery_goal" :disabled="pageStates.isUpdate">
            <el-radio-button v-for="goal in smartDeliveryGoalList" :key="goal.value" ghost :label="goal.value">
              {{ goal.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.FIRST_DAY_PURCHASE_ROI">
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'register_cost'"
            label="注册成本"
            prop="register_cost"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.register_cost"
              placeholder="注册成本的范围是0.01~20000"
            ></el-input>
          </el-form-item>
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'first_day_purchase_roi'"
            label="首日付费ROI"
            prop="first_day_purchase_roi"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.first_day_purchase_roi"
              placeholder="首日付费ROI的范围是0.001~50"
            ></el-input>
          </el-form-item>
        </template>

        <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI">
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'register_cost'"
            label="注册成本"
            prop="register_cost"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.register_cost"
              placeholder="注册成本的范围是0.01~20000"
            ></el-input>
          </el-form-item>
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'seven_day_purchase_roi'"
            label="7日付费ROI"
            prop="seven_day_purchase_roi"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.seven_day_purchase_roi"
              placeholder="7日付费ROI的范围是0.001~50"
            ></el-input>
          </el-form-item>
        </template>

        <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.DAY30_PURCHASE">
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'register_cost'"
            label="注册成本"
            prop="register_cost"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.register_cost"
              placeholder="注册成本的范围是0.01~20000"
            ></el-input>
          </el-form-item>
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'day30_purchase_roi'"
            label="30日付费ROI"
            prop="day30_purchase_roi"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.day30_purchase_roi"
              placeholder="30日付费ROI的范围是0.001~50"
            ></el-input>
          </el-form-item>
        </template>

        <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.IAAP_MIX_IN_ONE">
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'iaap_roi'"
            label="混变ROI"
            prop="iaap_roi"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.iaap_roi"
              placeholder="混变ROI的范围是0.01~50"
            ></el-input>
          </el-form-item>
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'iaap_mix_in_one_factor'"
            label="混变系数"
            prop="iaap_mix_in_one_factor"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.iaap_mix_in_one_factor"
              placeholder="混变系数的范围是0.001~50"
            ></el-input>
          </el-form-item>
        </template>

        <template v-if="[SMART_DELIVERY_GOAL.FIRST_DAY_MONETIZATION, SMART_DELIVERY_GOAL.SEVEN_DAY_MONETIZATION, SMART_DELIVERY_GOAL.APP_REGISTER_30DAY_MONETIZATION_ROAS].includes(budgetForm.smart_delivery_goal)">
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'bid_amount'"
            label="注册出价"
            prop="version_smart_bid_amount_spec"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.bid_amount_spec.bid_amount"
              placeholder="请输入注册成本"
            ></el-input>
          </el-form-item>
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'monetization_roi'"
            label="变现ROI"
            prop="monetization_roi"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.smart_promotion_spec.monetization_roi"
              placeholder="变现ROI的范围是0.001~50"
            ></el-input>
          </el-form-item>
        </template>

        <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.BACK_FLOW_1DAY_PURCHASE_ROAS">
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'bid_amount'"
            label="沉默唤起成本"
            prop="version_smart_bid_amount_deep_conversion_worth_rate_spec"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.bid_amount_deep_conversion_worth_rate_spec.bid_amount"
              placeholder="请输入沉默唤起成本"
            ></el-input>
          </el-form-item>
          <el-form-item
            :key="planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + 'deep_conversion_worth_rate'"
            label="首日付费ROI"
            prop="back_flow_deep_conversion_worth_rate"
          >
            <el-input
              style="width: 290px"
              v-model="budgetForm.bid_amount_deep_conversion_worth_rate_spec.deep_conversion_worth_rate"
              placeholder="首日付费ROI的范围是0.001~50"
            ></el-input>
          </el-form-item>
        </template>
      </template>

      <!-- 游戏应用智投 -->
      <template v-if="planForm.smart_delivery_platform === SMART_DELIVERY_PLATFORM.GAME_APP">
        <el-form-item
          label="智投投放目标"
          :key="marketingSceneType.version_smart + planForm.smart_delivery_platform"
          prop="smart_delivery_platform"
        >
          <el-radio-group v-model="budgetForm.smart_delivery_goal" :disabled="pageStates.isUpdate">
            <el-radio-button v-for="goal in SMART_DELIVERY_GOAL_APP_LIST" :key="goal.value" ghost :label="goal.value">
              {{ goal.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <template v-if="budgetForm.bid_scene === BID_SCENE.NORMAL_AVERAGE">
          <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.GAME_APP_ACTIVATE_ROI_1DAY">
            <el-form-item
              :key="marketingSceneType.version_smart + planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + ' bid_amount'"
              label="激活成本"
              prop="version_smart_game_app_activate_roi_spec"
            >
              <el-input
                style="width: 290px"
                v-model="budgetForm.game_app_activate_roi_spec.bid_amount"
                placeholder="请输入激活成本"
              ></el-input>
            </el-form-item>
            <el-form-item
              :key="
                marketingSceneType.version_smart +
                planForm.smart_delivery_platform +
                budgetForm.smart_delivery_goal +
                ' deep_conversion_worth_rate'
              "
              label="首日付费ROI"
              prop="deep_conversion_worth_rate"
            >
              <el-input
                style="width: 290px"
                v-model="budgetForm.game_app_activate_roi_spec.deep_conversion_worth_rate"
                placeholder="首日付费ROI的范围是0.001~50"
              ></el-input>
            </el-form-item>
          </template>

          <template v-else>
            <el-form-item
              :key="marketingSceneType.version_smart + planForm.smart_delivery_platform + budgetForm.smart_delivery_goal + ' bid_amount'"
              :label="getSmartDeliveryGoalLabel"
              prop="version_smart_bid_amount_spec"
            >
              <el-input
                style="width: 290px"
                v-model="budgetForm.bid_amount_spec.bid_amount"
                :placeholder="`请输入${getSmartDeliveryGoalLabel}成本`"
              ></el-input>
            </el-form-item>
          </template>
        </template>
      </template>
    </template>

    <template v-if="marketingSceneType.version3 || marketingSceneType.version_search">
      <!-- 出价和优化目标、深度优化目标 -->
      <BidAndOptGoal v-if="budgetForm && budgetForm.optimization_goal" v-model="budgetForm" :plan-form="planForm"></BidAndOptGoal>
    </template>

    <!-- 广告场景 腾讯广告3.0 -->
    <template v-if="marketingSceneType.version3">
      <!-- 一键起量 -->
      <el-form-item label="一键起量">
        <el-switch v-model="budgetForm.auto_acquisition_enabled"></el-switch>
      </el-form-item>

      <el-form-item prop="autoAcquisitionBudget" label="一键起量预算" v-if="budgetForm.auto_acquisition_enabled">
        <el-input v-model="budgetForm.auto_acquisition_budget" style="width: 188px" placeholder="请输入预算"></el-input>
      </el-form-item>

      <el-form-item label="搜索场景扩量">
        <el-switch
          v-model="budgetForm.search_expansion_switch"
          :active-value="SEARCH_EXPANSION_SWITCH.OPEN"
          :inactive-value="SEARCH_EXPANSION_SWITCH.CLOSE"
          :disabled="pageStates.isUpdate"
        ></el-switch>
        <el-tooltip class="item" effect="dark" placement="top">
          <span slot="content" style="display: inline-block; width: 220px">
            计划将有机会投放至QQ浏览器、搜一搜等搜索流量场景，获取更多曝光。
          </span>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-form-item>

      <el-form-item label="定向扩展" v-if="budgetForm.search_expansion_switch === SEARCH_EXPANSION_SWITCH.OPEN">
        <el-switch
          v-model="budgetForm.search_expand_targeting_switch"
          :active-value="SEARCH_EXPAND_TARGETING_SWITCH.OPEN"
          :inactive-value="SEARCH_EXPAND_TARGETING_SWITCH.CLOSE"
          :disabled="pageStates.isUpdate"
        ></el-switch>

        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content" style="display: inline-block; width: 320px">
            <p>1.搜索计划通过关键词触发流量，设置过多定向会影响跑量效果</p>
            <p>2.启用该功能后搜索流量场景下年龄、性别、学历定向将被设置为不限 （不影响其他定向设置及非搜索流量场景下的任何定向设置）</p>
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-form-item>
    </template>

    <template v-if="marketingSceneType.version3 || marketingSceneType.version_smart">
      <!-- 投放素材标签 -->
      <slot name="materialTags"></slot>

      <el-form-item label="自动衍生创意">
        <el-switch v-model="budgetForm.auto_derived_creative_enabled" :disabled="pageStates.isUpdate"></el-switch>
        <el-tooltip class="item" effect="dark" placement="top">
          <span slot="content" style="display: inline-block; width: 320px">
            1.使用自动衍生创意，系统将优选计划下多个创意的多个组件，自动衍生新的组件并组成新的创意。在创意列表中，可通过“客户自建创意”、“妙思自动生成”类型进行区分；<br />
            2.计划提交后不支持再次修改
          </span>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-form-item>
    </template>

    <el-form-item label="创建转化类型" v-if="!pageStates.isUpdate">
      <el-radio-group v-model="budgetForm.access_type">
        <el-radio-button ghost :label="ACCESS_TYPE.SDK" :disabled="sdkAccessTypeDisabled.sdk">SDK类型</el-radio-button>
        <el-radio-button ghost :label="ACCESS_TYPE.API" :disabled="sdkAccessTypeDisabled.api">API类型</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>
<script>
import DragWeektime from '@/views/edit/kuaishou/components/time-range/index.vue'
import weektimeData from '@/data/tencent/weektime_data'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import BidAndOptGoal from './bid-goal.vue'
import { PLATFORM, MARKETING_SUB_GOAL, AD_MARKETING_SCENE, SMART_DELIVERY_PLATFORM } from '@/views/create/gdt/model/project-const.js'

import { WECHAT_SITES } from '@/views/create/gdt/model/siteset/siteset-const.js'
import BUDGET_CONST from '@/views/create/gdt/model/budget/budget-const.js'

import budgetFormRules from '@/views/create/gdt/model/budget/budget-rules.js'
import { projectComputedMethods } from '@/views/create/gdt/model/project-mixins.js'
import { BID_ADJUSTMENT_COEFFICIENT, BID_ADJUSTMENT_SITE_OPTIONS } from '@/views/create/gdt/model/budget/bid-adjustment.js'

export default {
  props: {
    value: {
      type: Object
    },
    formLabelWidth: {
      type: String,
      default: '180px'
    },
    planForm: {
      type: Object
    }
  },
  components: { DateRangePicker, DragWeektime, BidAndOptGoal },
  provide() {
    return {
      parentInstance: this
    }
  },
  data() {
    return {
      // OPT_GOAL
      ...BUDGET_CONST,
      BID_ADJUSTMENT_SITE_OPTIONS,
      SMART_DELIVERY_PLATFORM,
      MARKETING_SUB_GOAL,
      weektimeData,
      pickerOpts: {
        disabledDate(date) {
          // 日期只能大于等于当天
          return date && date.valueOf() < Date.now() - 1000 * 60 * 60 * 24
        }
      },
      rules: budgetFormRules.call(this)
    }
  },
  watch: {
    'planForm.ad_marketing_scene'(newVal) {
      // 搜索广告下出价方式设置为ocpc
      if (newVal === AD_MARKETING_SCENE.VERSION_SEARCH) {
        this.budgetForm = { ...this.budgetForm, bid_mode: this.BID_MODE.OCPC }
      }
      this.clearValidate()
    },
    'planForm.marketing_sub_goal'(val) {
      // 切离新游测试/新客增长时，若当前选的是「沉默唤起+首日付费ROI」，回落到7日付费ROI
      const allowBackFlow = [
        MARKETING_SUB_GOAL.NEW_GAME_TEST,
        MARKETING_SUB_GOAL.MINI_GAME_NEW_CUSTOMER_GROWTH
      ].includes(val)
      if (
        !allowBackFlow &&
        this.budgetForm.smart_delivery_goal === BUDGET_CONST.SMART_DELIVERY_GOAL.BACK_FLOW_1DAY_PURCHASE_ROAS
      ) {
        this.budgetForm = {
          ...this.budgetForm,
          smart_delivery_goal: BUDGET_CONST.SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI
        }
      }
    }
  },
  computed: {
    // pageStates
    ...projectComputedMethods,
    budgetForm: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    dailyBudgetDisabled() {
      const { bid_scene, smart_bid_type } = this.budgetForm
      const isNormalMax = bid_scene === BUDGET_CONST.BID_SCENE.NORMAL_MAX
      const isSystematic = smart_bid_type === BUDGET_CONST.SMART_BID_TYPE.SYSTEMATIC
      // 最大转化量
      if (isNormalMax) return true
      // 自动出价
      if (isSystematic) return true
      return false
    },

    /**
     * @description: 非安卓平台时，SDK转化类型禁用
     */
    sdkAccessTypeDisabled() {
      const { ch_platform_id } = this.planForm
      const { isV3 } = this.pageStates

      const states = {
        //  禁用ios、小游戏平台的sdk转化
        sdk: ch_platform_id === PLATFORM.IOS || ch_platform_id === PLATFORM.MINIGAME,
        api: false
      }

      if (isV3) {
        // v3 禁用安卓的api转化
        states.api = ch_platform_id === PLATFORM.ANDROID
      }

      return states
    },
    isMiniProgram() {
      return this.planForm.ch_platform_id === PLATFORM.MINIGAME
    },
    marketingSceneType() {
      const { ad_marketing_scene } = this.planForm
      return {
        version3: typeof ad_marketing_scene === 'undefined' || ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3,
        version_smart: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART,
        version_search: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
      }
    },
    getSmartDeliveryGoalLabel() {
      return BUDGET_CONST.SMART_DELIVERY_GOAL_APP_LIST.find((goal) => goal.value === this.budgetForm.smart_delivery_goal)?.label || ''
    },
    /**
     * @description: 小游戏跑量智投投放目标列表
     * 「沉默唤起+首日付费ROI」仅在子目的为新游测试/新客增长时可选
     */
    smartDeliveryGoalList() {
      const { marketing_sub_goal } = this.planForm
      const allowBackFlow = [
        MARKETING_SUB_GOAL.NEW_GAME_TEST,
        MARKETING_SUB_GOAL.MINI_GAME_NEW_CUSTOMER_GROWTH
      ].includes(marketing_sub_goal)
      if (allowBackFlow) return BUDGET_CONST.SMART_DELIVERY_GOAL_LIST
      return BUDGET_CONST.SMART_DELIVERY_GOAL_LIST.filter(
        (goal) => goal.value !== BUDGET_CONST.SMART_DELIVERY_GOAL.BACK_FLOW_1DAY_PURCHASE_ROAS
      )
    },
    bidAdjustmentCoefficientPlaceholder() {
      const { MIN, MAX } = BID_ADJUSTMENT_COEFFICIENT
      return `${MIN}-${MAX}`
    },
    bidAdjustmentCoefficientTip() {
      const { MIN, MAX, DECIMAL_PLACES } = BID_ADJUSTMENT_COEFFICIENT
      return `范围 ${MIN}~${MAX}，最多可带${DECIMAL_PLACES}位小数`
    }
  },
  created() {
    this.initEventBus()
  },
  methods: {
    initEventBus() {
      // platformChange 监听游戏平台变化
      this.$bus.$on('platformChange', this.onPlatformChange)
    },
    /**
     * @description: 回显投放时间区间，保存到projectForm，用于项目信息预览显示
     * @param {*} schedule
     * @param {*} readableWeekdays
     */
    onWeektimeChange(schedule, readableWeekdays) {
      const newForm = { ...this.budgetForm, readableWeekdays }
      this.budgetForm = newForm
    },
    onBidSceneChange(scene) {
      // 日预算切换到设置预算
      if (scene === BUDGET_CONST.BID_SCENE.NORMAL_MAX) {
        this.budgetForm = {
          ...this.budgetForm,
          budget: 1,
          bid_amount: ''
        }
      }
    },

    onBidAdjustmentEnabledChange(enabled) {
      if (!enabled) {
        this.$nextTick(() => {
          this.$refs.bidForm.clearValidate([
            'bid_adjustment_site_set',
            'bid_adjustment_shallow_coefficient',
            'bid_adjustment_deep_coefficient'
          ])
        })
      }
    },
    onBidAdjustmentSiteSetChange() {
      this.$set(this.budgetForm, 'bid_adjustment_unknown_sites', [])
    },
    onBidAdjustmentCoefficientsInput() {
      this.$set(this.budgetForm, 'bid_adjustment_coefficients_reentry_required', false)
    },

    /**
     * @description: 切换应用平台
     */
    onPlatformChange() {
      const newForm = { ...this.budgetForm }
      const { ch_platform_id } = this.planForm
      if (this.isMiniProgram) {
        // 小程序平台，切换到[首次付费]
        newForm.optimization_goal = BUDGET_CONST.OPT_GOAL.FIRST_PURCHASE

        // 切换平台时，小游戏智投优化目标切换到[7天付费roi]
        if (this.marketingSceneType.version_smart) {
          newForm.smart_delivery_goal = BUDGET_CONST.SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI
        }
      } else {
        // 切换平台时，app智投优化目标切换到[激活和首日付费roi]
        if (this.marketingSceneType.version_smart) {
          newForm.smart_delivery_goal = BUDGET_CONST.SMART_DELIVERY_GOAL.GAME_APP_ACTIVATE_ROI_1DAY
        }
      }

      // 腾讯广告3.0 切换应用平台时，安卓只能选sdk 、 ios、小游戏只能选api
      if (this.pageStates.isV3) {
        newForm.access_type =
          ch_platform_id === PLATFORM.IOS || ch_platform_id === PLATFORM.MINIGAME
            ? BUDGET_CONST.ACCESS_TYPE.API
            : BUDGET_CONST.ACCESS_TYPE.SDK
      } else {
        // 腾讯广告ada 切换应用平台时，ios只能选api， 安卓都能选
        if (ch_platform_id === PLATFORM.IOS) {
          newForm.access_type = BUDGET_CONST.ACCESS_TYPE.API
        }
      }
      this.budgetForm = newForm
    },
    formValidate() {
      return this.$refs.bidForm.validate()
    },
    clearValidate() {
      this.$refs.bidForm.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin mt-6px {
  margin-top: 6px;
}
.mt-6px {
  @include mt-6px;
}
.project-budget {
  display: flex;
  @include mt-6px;
  ::v-deep .el-input {
    width: 188px;
  }
  > span {
    font-size: 12px;
  }
}

.bid-adjustment-panel {
  margin-bottom: 22px;
  border-radius: 8px;
  padding: 16px 0 1px;
  background: #f8f9fc;

  ::v-deep .el-select {
    width: 320px;
  }
}

.bid-adjustment-coefficient {
  width: 120px;
}

.bid-adjustment-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.bid-input {
  ::v-deep .el-input {
    width: 188px;
  }
}
</style>
